import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  
  private key: string;

  constructor() { 
    this.key = environment.apiKey;
  }
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);
      
    const reqUpdate = req.clone({
      headers: headers
    });

    return next.handle(reqUpdate);
  }
}
